// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606171203/js/" + chunkId + "." + {"44":"e0a99669","225":"2aaad4cb","481":"d1756106","486":"4d332120","770":"8fab89f2"}[chunkId] + ".0.8379869293166405.chunk.js";
};